import React from 'react';
import { Col, Form, Row, Select } from 'antd';

import { COMPARISON_TYPE } from '@/views/Bera/constants';
import { getComparisonOptions } from '@/views/Bera/_components/Filter/utils';

import type { BeraFilterFormFields } from '@/views/Bera/types';

const { useFormInstance, useWatch } = Form;

type ComparisonFieldName = 'type_overall_score' | 'type_rpn';

interface ComparisonFieldProps {
	name: ComparisonFieldName;
	label: string;
	minimum: JSX.Element;
	maximum: JSX.Element;
	onClear: () => void;
}

export function ComparisonField({ name, label, minimum, maximum, onClear }: Readonly<ComparisonFieldProps>): JSX.Element {
	const form = useFormInstance<BeraFilterFormFields>();

	const comparisonType = useWatch(name, form);

	const inputMapper: Record<string, JSX.Element> = {
		[COMPARISON_TYPE.GREATER]: minimum,
		[COMPARISON_TYPE.GREATER_OR_EQUAL]: minimum,
		[COMPARISON_TYPE.LESS]: maximum,
		[COMPARISON_TYPE.LESS_OR_EQUAL]: maximum,
		[COMPARISON_TYPE.BETWEEN]: (
			<Row gutter={[32, 6]}>
				{minimum}
				{maximum}
			</Row>
		)
	};

	const comparisonInput = inputMapper[comparisonType ?? ''];

	return (
		<Col xs={24}>
			<Form.Item name={name} label={label} labelCol={{ span: 24 }} style={{ marginBottom: '1rem' }}>
				<Select allowClear onClear={onClear} options={getComparisonOptions()} placeholder={label} />
			</Form.Item>
			{comparisonInput}
		</Col>
	);
}
